import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import getIn from 'transmute/getIn';
import { getOperatorLabelTranslationKey as _getOperatorLabelTranslationKey } from 'customer-data-filters-ui/components/operator/FilterOperatorLabelTranslations';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
const DEFAULT = 'DEFAULT';
const i18nPrefix = 'newCustomerDataFilters.filterOperatorLabelTranslations';
const operatorLabelTranslationKeys = Object.freeze({
  [DEFAULT]: Object.freeze({
    // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
    [Operators.FormFilledOut]: `${i18nPrefix}.DEFAULT.FormFilledOut`,
    // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
    [Operators.FormNotFilledOut]: `${i18nPrefix}.DEFAULT.FormNotFilledOut`
  })
});
export const getOperatorLabelTranslationKey = (Operator, field, useRefinementLabel, translationPrefix) => {
  const translationKey = getIn([DEFAULT, Operator.toString()], operatorLabelTranslationKeys);
  const key = translationKey || _getOperatorLabelTranslationKey(Operator, field, useRefinementLabel);
  if (translationPrefix && isValidI18nKey(`${translationPrefix}.${key}`)) {
    return `${translationPrefix}.${key}`;
  }
  return key;
};